var chart;
var modalChart;
var st;
var getFigure="";
function renderChart2(chartId, legendDivId) {

    var chartData = [];
    
    //changing datapeakinfo 1st graph value to max at left
    //datapoint1Peakinfo.PeakInfo[0].xval=20;
    var peakinfo1 = datapoint1Peakinfo.PeakInfo;
    var peakinfo2 = datapoint4Peakinfo.PeakInfo;
    var peakinfo3 = datapoint3Peakinfo.PeakInfo;

    generateChartData();

    function generateChartData() {
        var datasetarray1 = datapoint1.data;
        for (var i = 0; i < datasetarray1.length; i++) {
            var xVal = datasetarray1[i][0];
            var yVal = datasetarray1[i][1];
            var flag = 0;

            for (var j = 0; j < peakinfo1.length; j++) {

                if (parseFloat(xVal) == parseFloat(peakinfo1[j].xval)) {
                    chartData.push({
                        "eV": xVal,
                        "intensity": yVal,
                        "label": peakinfo1[j].lbltext
                    })
                    flag = 1;
                }
            }

            if (flag == 0) {
                chartData.push({
                    "eV": xVal,
                    "intensity": yVal
                })
            }

        }

        var datasetarray2 = datapoint4.data;
        for (var i = 0; i < datasetarray2.length; i++) {
            var xVal = datasetarray2[i][0];
            var yVal = datasetarray2[i][1];
            var flag = 0;

            for (var j = 0; j < peakinfo2.length; j++) {

                if (parseFloat(xVal) == parseFloat(peakinfo2[j].xval)) {
                    chartData.push({
                        "eV": xVal,
                        "intensity2": yVal,
                        "label": peakinfo2[j].lbltext
                    })
                    flag = 1;
                }
            }

            if (flag == 0) {
                chartData.push({
                    "eV": xVal,
                    "intensity2": yVal
                })
            }

        }

        var datasetarray3 = datapoint3.data;
        for (var i = 0; i < datasetarray3.length; i++) {
            var xVal = datasetarray3[i][0];
            var yVal = datasetarray3[i][1];
            var flag = 0;

            for (var j = 0; j < peakinfo3.length; j++) {

                if (parseFloat(xVal) == parseFloat(peakinfo3[j].xval)) {
                    chartData.push({
                        "eV": xVal,
                        "intensity3": yVal,
                        "label": peakinfo3[j].lbltext
                    })
                    flag = 1;
                }
            }

            if (flag == 0) {
                chartData.push({
                    "eV": xVal,
                    "intensity3": yVal
                })
            }

        }


    }
    //Set flag for figures
    $(".graph-figures input[type=radio]").each(function(){
        if($(this).prop("checked")==true){
            getFigure=$(this).attr("graph-figures");
        }
    });
    
        if(getFigure=="AES"){
            st=true;
        }else{
                st=false;
            }
     chart = AmCharts.makeChart(chartId, {
        "type": "xy",
        "zoomOutButtonAlpha": 1,
        /*"marginRight": 50,
        "autoMarginOffset": 20,
        "marginTop": 7,*/
        "export": {
            "enabled": true
        },
       /* "chartCursorSettings": {
            "valueBalloonsEnabled": true,
            "fullWidth": true,
            "cursorAlpha": 0.1,
            "valueLineBalloonEnabled": true,
            "valueLineEnabled": true,
            "valueLineAlpha": 0.5
        },*/
        "mouseWheelZoomEnabled": true,
		/*"valueAxes": [{
            "id": "v1",
            "gridAlpha": 0,
            "axisAlpha": 1,
            "position": "bottom",
            "tickLength":0,
            "offset":50
          }, {
            "id": "v2",
            "gridAlpha": 0,
            "axisAlpha": 1,
            "position": "bottom",
            "tickLength":0,
            "offset":0
          }, {
            "id": "v3",
            "gridAlpha": 0,
            "axisAlpha": 1,
            "tickLength":0,
            "position": "bottom",
            "offset":0
          }],
         "valueAxes": [{
            "axisAlpha": 0.2,
            "dashLength": 1,
            "position": "left"
        }],*/
        "graphs": [
            {
                "gid": "AmGraph-1",
				"valueAxis": "v1",
                "title": "Si (100)/ survey",
                "type": "line",
                "lineAlpha": 1,
                "xField": "eV",
                "yField": "intensity",
                "lineColor": '#FF9E01',
                "labelText": "[[label]]",
                "color": '#FF9E01'
		}, {
                "gid": "AmGraph-2",
				"valueAxis": "v2",
                "title": "Kovar sheet, 700C treatment/ survey",
                "type": "line",
                "lineAlpha": 1,
                "xField": "eV",
                "yField": "intensity2",
                "lineColor": '#FF0811',
                "labelText": "[[label]]",
                "color": '#FF0811'
		}, {
                "gid": "AmGraph-3",
				"valueAxis": "v3",
                "title": "Al2O3 thin film/ survey",
                "type": "line",
                "lineAlpha": 1,
                "xField": "eV",
                "yField": "intensity3",
                "lineColor": '#084bff',
                "labelText": "[[label]]",
                "color": '#084bff'
            
		}

	],
    "valueAxes": [
        {
          "title": "Binding energy (eV)",
          "position": "bottom",
          "reversed":st,
        },
        {
          "title": "Intensity (Counts/s)",
          "position": "left"    
        }
      ],
	  /*"chartCursor": {
        "oneBalloonOnly": true
      },*/
    /*"chartScrollbar": {
        "autoGridCount": true,
        "graph": "g1",
        "scrollbarHeight": 25
    },*/
    /*"chartCursor": {
       "limitToGraph":"g1"
    },  */   
       /* "zoomControl": {
		"zoomControlEnabled": true
	},*/
        "dataProvider": chartData
    });
    //Zoom part
/*chart.addListener("rendered", zoomChart);
zoomChart();

// this method is called when chart is first inited as we listen for "rendered" event
function zoomChart() {
    // different zoom methods can be used - zoomToIndexes, zoomToDates, zoomToCategoryValues
    chart.zoomToIndexes(chartData.length - 500, chartData.length - 50);
}*/
function handleLegendClick( graph ) {
  var chartVar = graph.chart;
  for( var i = 0; i < chartVar.graphs.length; i++ ) {
    if ( graph.id == chartVar.graphs[i].id ){
        var graphRow=$("#graph-row-"+i);
         if($(graphRow).children().find(".show-hide-graph").hasClass("fa-eye")){
            $(graphRow).find(".show-hide-graph").toggleClass("fa-eye-slash fa-eye");
              $(graphRow).find(".show-hide-graph").attr("title","Show graph");
             chartVar.hideGraph(chartVar.graphs[i]);
             var chart1 = modalChart.graphs[i].chart;
              chart1.hideGraph(modalChart.graphs[i]);
         } else {
            $(graphRow).find(".show-hide-graph").toggleClass("fa-eye-slash fa-eye");
             $(graphRow).find(".show-hide-graph").attr("title","Hide graph");
             chartVar.showGraph(chartVar.graphs[i]);
             var chart1 = modalChart.graphs[i].chart;
              chart1.showGraph(modalChart.graphs[i]);
         }
        //Hide amcharts text on graph
        $("#chartdiv").find(".amcharts-chart-div a").hide();
        $("#chartModal .modal-body").find(".amcharts-chart-div a").hide();
      }
  } 
  
  // return false so that default action is canceled
  return false;
}

    var legend = new AmCharts.AmLegend();
    legend.position = "left"
    legend.align = "center";
    legend.markerType = "square";
    legend.valueText = "title";
    legend.clickMarker = handleLegendClick;
    legend.clickLabel = handleLegendClick
    
    chart.addLegend(legend, legendDivId);
    
    //legend.addListener("clickLabel", handleClick)

function handleClick(event){
    console.log(event);
}
    
    
   
}

function renderModalChart(chartId, legendDivId) {

    var chartData = [];
    
    //changing datapeakinfo 1st graph value to max at left
    //datapoint1Peakinfo.PeakInfo[0].xval=20;
    var peakinfo1 = datapoint1Peakinfo.PeakInfo;
    var peakinfo2 = datapoint4Peakinfo.PeakInfo;
    var peakinfo3 = datapoint3Peakinfo.PeakInfo;

    generateChartData();

    function generateChartData() {
        var datasetarray1 = datapoint1.data;
        for (var i = 0; i < datasetarray1.length; i++) {
            var xVal = datasetarray1[i][0];
            var yVal = datasetarray1[i][1];
            var flag = 0;

            for (var j = 0; j < peakinfo1.length; j++) {

                if (parseFloat(xVal) == parseFloat(peakinfo1[j].xval)) {
                    chartData.push({
                        "eV": xVal,
                        "intensity": yVal,
                        "label": peakinfo1[j].lbltext
                    })
                    flag = 1;
                }
            }

            if (flag == 0) {
                chartData.push({
                    "eV": xVal,
                    "intensity": yVal
                })
            }

        }

        var datasetarray2 = datapoint4.data;
        for (var i = 0; i < datasetarray2.length; i++) {
            var xVal = datasetarray2[i][0];
            var yVal = datasetarray2[i][1];
            var flag = 0;

            for (var j = 0; j < peakinfo2.length; j++) {

                if (parseFloat(xVal) == parseFloat(peakinfo2[j].xval)) {
                    chartData.push({
                        "eV": xVal,
                        "intensity2": yVal,
                        "label": peakinfo2[j].lbltext
                    })
                    flag = 1;
                }
            }

            if (flag == 0) {
                chartData.push({
                    "eV": xVal,
                    "intensity2": yVal
                })
            }

        }

        var datasetarray3 = datapoint3.data;
        for (var i = 0; i < datasetarray3.length; i++) {
            var xVal = datasetarray3[i][0];
            var yVal = datasetarray3[i][1];
            var flag = 0;

            for (var j = 0; j < peakinfo3.length; j++) {

                if (parseFloat(xVal) == parseFloat(peakinfo3[j].xval)) {
                    chartData.push({
                        "eV": xVal,
                        "intensity3": yVal,
                        "label": peakinfo3[j].lbltext
                    })
                    flag = 1;
                }
            }

            if (flag == 0) {
                chartData.push({
                    "eV": xVal,
                    "intensity3": yVal
                })
            }

        }


    }


     modalChart = AmCharts.makeChart(chartId, {
        "type": "xy",
        "zoomOutButtonAlpha": 1,
        /*"marginRight": 50,
        "autoMarginOffset": 20,
        "marginTop": 7,*/
        "export": {
            "enabled": true
        },
       /* "chartCursorSettings": {
            "valueBalloonsEnabled": true,
            "fullWidth": true,
            "cursorAlpha": 0.1,
            "valueLineBalloonEnabled": true,
            "valueLineEnabled": true,
            "valueLineAlpha": 0.5
        },*/
        "mouseWheelZoomEnabled": true,
		/*"valueAxes": [{
            "id": "v1",
            "gridAlpha": 0,
            "axisAlpha": 1,
            "position": "bottom",
            "tickLength":0,
            "offset":50
          }, {
            "id": "v2",
            "gridAlpha": 0,
            "axisAlpha": 1,
            "position": "bottom",
            "tickLength":0,
            "offset":0
          }, {
            "id": "v3",
            "gridAlpha": 0,
            "axisAlpha": 1,
            "tickLength":0,
            "position": "bottom",
            "offset":0
          }],
         "valueAxes": [{
            "axisAlpha": 0.2,
            "dashLength": 1,
            "position": "left"
        }],*/
        "graphs": [
            {
                "gid": "AmGraph-1",
				"valueAxis": "v1",
                "title": "Si (100)/ survey",
                "type": "line",
                "lineAlpha": 1,
                "xField": "eV",
                "yField": "intensity",
                "lineColor": '#FF9E01',
                "labelText": "[[label]]",
                "color": '#FF9E01'
		}, {
                "gid": "AmGraph-2",
				"valueAxis": "v2",
                "title": "Kovar sheet, 700C treatment/ survey",
                "type": "line",
                "lineAlpha": 1,
                "xField": "eV",
                "yField": "intensity2",
                "lineColor": '#FF0811',
                "labelText": "[[label]]",
                "color": '#FF0811'
		}, {
                "gid": "AmGraph-3",
				"valueAxis": "v3",
                "title": "Al2O3 thin film/ survey",
                "type": "line",
                "lineAlpha": 1,
                "xField": "eV",
                "yField": "intensity3",
                "lineColor": '#084bff',
                "labelText": "[[label]]",
                "color": '#084bff'
            
		}

	],
    "valueAxes": [
        {
          "title": "Binding energy (eV)",
          "position": "bottom",
          "reversed":st,
        },
        {
          "title": "Intensity (Counts/s)",
          "position": "left"    
        }
      ],
	  /*"chartCursor": {
        "oneBalloonOnly": true
      },*/
    /*"chartScrollbar": {
        "autoGridCount": true,
        "graph": "g1",
        "scrollbarHeight": 25
    },*/
    /*"chartCursor": {
       "limitToGraph":"g1"
    },  */   
       /* "zoomControl": {
		"zoomControlEnabled": true
	},*/
        "dataProvider": chartData
    });
    //Zoom part
/*chart.addListener("rendered", zoomChart);
zoomChart();

// this method is called when chart is first inited as we listen for "rendered" event
function zoomChart() {
    // different zoom methods can be used - zoomToIndexes, zoomToDates, zoomToCategoryValues
    chart.zoomToIndexes(chartData.length - 500, chartData.length - 50);
}*/
function handleModalLegendClick( graph ) {
  //var chart = graph.chart;
  for( var i = 0; i < modalChart.graphs.length; i++ ) {
    if ( graph.id == modalChart.graphs[i].id ){
        var graphRow=$("#graph-row-"+i);
         if($(graphRow).children().find(".show-hide-graph").hasClass("fa-eye")){
              $(graphRow).find(".show-hide-graph").toggleClass("fa-eye-slash fa-eye");
              $(graphRow).find(".show-hide-graph").attr("title","Show graph");
              modalChart.hideGraph(modalChart.graphs[i]);
              var chart1 = chart.graphs[i].chart;
              chart1.hideGraph(chart.graphs[i]);
         } else {
            $(graphRow).find(".show-hide-graph").toggleClass("fa-eye-slash fa-eye");
             $(graphRow).find(".show-hide-graph").attr("title","Hide graph");
             modalChart.showGraph(modalChart.graphs[i]);
             var chart1 = chart.graphs[i].chart;
            chart1.showGraph(chart.graphs[i]);
         }
        //Hide amcharts text on graph
        $("#chartdiv").find(".amcharts-chart-div a").hide();
        $("#chartModal .modal-body").find(".amcharts-chart-div a").hide();
      }
  } 
  
  // return false so that default action is canceled
  return false;
}

    var legend = new AmCharts.AmLegend();
    legend.position = "left"
    legend.align = "center";
    legend.markerType = "square";
    legend.valueText = "title";
    legend.clickMarker = handleModalLegendClick;
    legend.clickLabel = handleModalLegendClick
    
    modalChart.addLegend(legend, legendDivId);
    
    //legend.addListener("clickLabel", handleClick)

function handleClick(event){
    console.log(event);
}
    
    
   
}
    
function handleClick(event)
{
    console.log("click");
    console.log(event);
}

function offsetChart(){
    
}
